<template>
  <div class="news-search">
    <!-- <h3 class="textNews4">News Search</h3>
    <v-divider /> -->
    <div v-if="editingProfileIndex !== -1">
  <!-- <form @submit.prevent="fetchNews" class="news-search">
    <input
      type="text"
      v-model="searchQuery"
      placeholder="Search for news articles"
      class="news-input"
    />
        <v-btn type="submit">Search News</v-btn>
      </form> -->
<!-- Display Articles -->
<div v-if="articles.length" class="news-articles">
    <h4>News Articles:</h4>
    <div
      v-for="(article, index) in articles"
      :key="index"
      class="article-card"
    >
      <h4>{{ article.title }}</h4>
      <p>{{ article.publishedAt }}</p>
      <img
        :src="article.urlToImage"
        alt="Article Image"
        class="article-image"
      />
      <v-btn small @click="saveArticleToProfile(article)">
        Save to Profile
      </v-btn>
    </div>
  </div>
</div>
    <div class="to-top">
      <div id="to-top-image"></div>
    </div>
    <form @submit.prevent="fetchNews" class="mainNews">
      <div>
        <label for="query" class="textNews2">Search Query:</label>
        <input
          type="text"
          id="query"
          v-model="searchQuery"
          placeholder="Enter search term"
          required
          class="textNews"
        />
      </div>
      <div>
        <label for="from" class="textNews2">From Date:</label>
        <input class="textNews" type="date" id="from" v-model="fromDate" />
      </div>
      <div>
        <label for="to" class="textNews2">To Date:</label>
        <input class="textNews" type="date" id="to" v-model="toDate" />
      </div>
      <div>
        <label for="sortBy" class="textNews2">Sort By:</label>
        <select id="sortBy" v-model="sortBy" class="textNews">
          <option value="relevancy">Relevancy</option>
          <option value="popularity">Popularity</option>
          <option value="publishedAt">Published At</option>
        </select>
      </div>
      <div class="domainSelect">
  <!-- <label for="domains" class="textNews2">News Channels:</label> -->
  <div>
    <label v-for="domain in domainOptions" :key="domain.value" class="domainOption">
      <input
        class="domainSelect"
        type="checkbox"
        :value="domain.value"
        v-model="selectedDomains"
      />
      <img :src="domain.image" :alt="domain.label" class="domainImage" />
      {{ domain.label }}
    </label>
  </div>
</div>


      <v-btn type="submit" class="buttonNews">Search</v-btn>
    </form>

    <div v-if="articles.length" class="results">
      <h4 class="textNews2">Results:</h4>
      <ul>
        <li v-for="(article, index) in articles" :key="index" class="article">
          <h3>{{ article.title }}</h3>
          
          <p>{{ article.author }}</p>
          <p>{{ article.publishedAt }}</p>
          <!-- <p>{{ article.description }}</p> -->
          <p>{{ article.content }}</p> 
          <img
            v-if="article.urlToImage"
            :src="article.urlToImage"
            alt="Article image"
            class="article-image"
          />

          <a :href="article.url" target="_blank" class="buttonNews">Read more...</a>
        </li>
      </ul>
    </div>
    <p v-else-if="loading">Loading...</p>
    <p v-else-if="error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: "",
      fromDate: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split("T")[0], // Defaults to a week prior
      toDate: "", // Optional
      sortBy: "relevancy", // Default sort option
      selectedDomains: [], // Array to store selected domains
      domainOptions: [

      { value: "cnn.com", image: require("@/assets/news/cnn.png") },
      { value: "theverge.com", image: require("@/assets/news/verge.png") },
      { value: "bbc.com", image: require("@/assets/news/bbc.png") },
      { value: "techcrunch.com", image: require("@/assets/news/techcrunch.png") },
      { value: "bloomberg.com", image: require("@/assets/news/bloomberg.png") },
      { value: "buzzfeed.com", image: require("@/assets/news/buzzfeed.png") },
      { value: "ew.com", image: require("@/assets/news/entertainment.png") },
      { value: "google.com", image: require("@/assets/news/google.png") },
      { value: "mashable.com", image: require("@/assets/news/mashable.png") },
      { value: "billboard.com", image: require("@/assets/news/billboard.png") },
      { value: "axios.com", image: require("@/assets/news/axios.png") },
      ],
      articles: [],
      loading: false,
      error: "",
      artistProfiles: JSON.parse(localStorage.getItem("artistProfiles")) || [],
      savedQueries: JSON.parse(localStorage.getItem("savedQueries")) || [],
    };
  },
  methods: {
    async fetchNews() {
      this.loading = true;
      this.error = "";
      this.articles = [];

      const baseUrl = "https://newsapi.org/v2/everything";
      const apiKey = "322c01340c6a449c8a61b4cb35c80e39"; // Replace with your API key

      const params = new URLSearchParams({
        q: this.searchQuery,
        from: this.fromDate,
        sortBy: this.sortBy,
        apiKey,
      });

      if (this.toDate) {
        params.append("to", this.toDate);
      }

      if (this.selectedDomains.length) {
        params.append("domains", this.selectedDomains.join(","));
      }

      try {
        const response = await fetch(`${baseUrl}?${params.toString()}`);
        if (!response.ok) throw new Error("Failed to fetch news articles");

        const data = await response.json();
        this.articles = data.articles;

        this.saveNewsToProfile(); // Save fetched articles to the artist profile
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    loadArtistName(index) {
      // Load artistName from CogneetivPredict.vue
      const query = this.savedQueries[index];
      if (query && query.artistName) {
        this.searchQuery = query.artistName;
        this.fetchNews(); // Automatically fetch news after setting the query
      } else {
        alert("Artist name not found in saved queries.");
      }
    },
    saveNewsToProfile() {
      if (this.searchQuery) {
        const profile = this.artistProfiles.find(
          (profile) => profile.artistName === this.searchQuery
        );
        if (profile) {
          if (!profile.newsArticles) {
            this.$set(profile, "newsArticles", []);
          }

          profile.newsArticles = [...profile.newsArticles, ...this.articles];
          localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
          alert("News articles saved to artist profile.");
        } else {
          alert("Artist profile not found.");
        }
      }
    },
  },
};
</script>

<style scoped>
main{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    flex-basis: 60%;
    margin-left: auto;
    padding-bottom: 60px;
}

h1, p, h3{
    display: block;
    margin: 20px 10px 20px 10px;
    width: 100%;
}

h2{
    margin-left: 10px;
}

h3{
    text-align: center;
}

.news-search {
  color: #78b59c;
  font-size: 20px;
  font-family: 'lato';
  background-color: rgba(12, 22, 27, 0.705);
  max-width: 1900px;
  padding: 20px 20px 20px 20px;
  margin-top: 0px;
  position: bottom;
  border-radius: 20px;
}

form {
  margin-bottom: 0px;
}

form div {
  margin-bottom: 10px;
}

button {
  padding: 10px 20px;
  cursor: pointer;
}

.results {
  margin-top: 20px;
}

.article {
  flex-basis: 50%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    background: rgba(12, 22, 27, 0.9);
    padding-bottom: 20px;
    padding-top: 20px;
    padding-block: 40px 40px 40px 40px;
    margin-block: 40px 40px 40px 40px;
    -webkit-box-shadow: 5px 5px 5px 5px #7D7D7D; 
    box-shadow: 5px 5px 5px 5px #7D7D7D;
    hyphens: auto;
}

.article-image {
  width: 100%;
    height: 220px;
    object-fit: cover;
    object-position: center;
}


.domainSelect {
  padding-block: 22px;
  margin-right: 22px;
  margin-left: 22px;
}

.textNews {
  color: #78b59c;
  font-size: 22px;
  font-family: 'lato';
  font-weight: thin;
  position: relative;
  left: 0%;
  right: 0px;
  margin-left: 20px;
}

.textNews2 {
  color: #fff;
  font-size: 22px;
  font-family: 'lato';
  font-weight: thin;
  position: relative;
  left: 0%;
  right: 0px;
  padding-right: 70px;
}

.textNews3 {
  color: #78b59c;
  font-size: 18px;
  font-family: 'lato';
  font-weight: thin;
  position: relative;
  left: 0%;
  right: 0px;
  margin-right: 30px;
  padding-block: 10px;
  padding-left: 10px;
  padding-right: 10px;
  text-decoration: none !important;
  outline-width: 2px;
  outline-color: #5a80bf;
    outline-style: solid;
    border-radius: 10px;
    animation: glow 1800ms ease-out infinite alternate;
    cursor: pointer;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
}
@keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
  .textNews4 {
  color: #78b59c;
  font-size: 26px;
  font-family: 'lato';
  font-weight: bold;
  position: relative;
  left: -46%;
  right: 0px;
}
.buttonNews {
  text-decoration: none !important;
  background: #78b59c;
  border-radius: 20px;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 0px;
  width: 250px;
  border: outline;
  opacity: 01;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  outline-color: #5a80bf;
  align-content: center;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

@media only screen and (max-width: 600px) {
  
.buttonNews {
  text-decoration: none !important;
  border-radius: 40px;
  padding: 20px;
  width: 10px;
  border: outline;
  opacity: 0.9;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  align: center;
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
}
.mainNews{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    flex-basis: 60%;
    margin-left: auto;
    padding-bottom: 60px;
}
.to-top{
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 10;
}

#to-top-image{
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: palegreen;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yNCAxMmMwIDYuNjIzLTUuMzc3IDEyLTEyIDEycy0xMi01LjM3Ny0xMi0xMiA1LjM3Ny0xMiAxMi0xMiAxMiA1LjM3NyAxMiAxMnptLTEgMGMwIDYuMDcxLTQuOTI5IDExLTExIDExcy0xMS00LjkyOS0xMS0xMSA0LjkyOS0xMSAxMS0xMSAxMSA0LjkyOSAxMSAxMXptLTExLjUtNC44MjhsLTMuNzYzIDQuNjA4LS43MzctLjY3OSA1LTYuMTAxIDUgNi4xMTItLjc1My42NjYtMy43NDctNC42MDR2MTEuODI2aC0xdi0xMS44Mjh6Ii8+PC9zdmc+");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 75%;
}

#to-top-image:hover{
    cursor: pointer;
    background-color: rgb(133, 223, 133);
}

</style>
